export enum AupRequestItemStatus {
    Active = 0,
    Archived = 1
}
